export const browserHistory = {
  push(link: string) {
    history.pushState(
      {},
      null,
      link,
    );
  },
};
